import {
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
} from '../../EmailCreationForm.constants'

export const ACCOUNTS_FIELDS = [
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
]
